/* tslint:disable */
/* eslint-disable */
/**
 * Streem API
 * The Streem API gives you access to information captured during Streem calls.  You can retrieve artifacts such as recordings, streemshots (including captured model/serial numbers), and much more.
 *
 * The version of the OpenAPI document: 0.1.0
 * Contact: support@streem.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { StreemApiExternalUserFromJSON, StreemApiExternalUserToJSON, } from './';
export function StreemApiChangeExternalUserIdResponseFromJSON(json) {
    return StreemApiChangeExternalUserIdResponseFromJSONTyped(json, false);
}
export function StreemApiChangeExternalUserIdResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'externalUser': !exists(json, 'external_user') ? undefined : StreemApiExternalUserFromJSON(json['external_user']),
    };
}
export function StreemApiChangeExternalUserIdResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'external_user': StreemApiExternalUserToJSON(value.externalUser),
    };
}
//# sourceMappingURL=StreemApiChangeExternalUserIdResponse.js.map